var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(" My Profile")]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.user.user.firstName))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.user.user.lastName))]),
      _vm._v(" "),
      _c("h2", [_vm._v(" Emails: ")]),
      _vm._v(" "),
      _vm._l(_vm.user.emails, function(e) {
        return _c("div", { key: e.address }, [_vm._v(_vm._s(e.address))])
      }),
      _vm._v(" "),
      _c("h2", [_vm._v(" Organizations: ")]),
      _vm._v(" "),
      _vm._l(_vm.user.organizations, function(org) {
        return _c("div", { key: org.organization_id }, [
          _c("hr"),
          _vm._v(" "),
          _c("div", [_c("h3", [_vm._v(_vm._s(org.name))])]),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                on: {
                  click: function($event) {
                    _vm.createInvite(org.organization_id)
                  }
                }
              },
              [_vm._v("Create Invite")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                on: {
                  click: function($event) {
                    _vm.deleteOrganization(org.organization_id)
                  }
                }
              },
              [_vm._v("Delete")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", [_vm._v("invites:")]),
              _vm._v(" "),
              _vm._l(org.invites, function(invite) {
                return _c("div", { key: invite }, [_vm._v(_vm._s(invite))])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("hr")
        ])
      }),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newOrgName,
              expression: "newOrgName"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.newOrgName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newOrgName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-secondary",
            on: {
              click: function($event) {
                _vm.createOrganization(_vm.newOrgName)
              }
            }
          },
          [_vm._v("Create Organization")]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inviteCode,
              expression: "inviteCode"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.inviteCode },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.inviteCode = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-secondary",
            on: {
              click: function($event) {
                _vm.joinOrganization(_vm.inviteCode)
              }
            }
          },
          [_vm._v("Join Organization")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0b1749", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0b1749","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile.vue
// module id = pXi0
// module chunks = 1